"use strict";
export function getUsdrPendingActionLabel(phase, translate) {
  switch (phase) {
    case "approving":
      return translate("common.approving");
    case "minting":
      return translate("common.minting");
    case "depositing":
      return translate("common.depositing");
    case "idle":
    case "preparing":
    case "switching-network":
      return void 0;
  }
  return void 0;
}
